import z from 'zod'

import {
  emailField,
  nameField,
  phoneNumberField,
} from '@maestro/commerce-blocks/schemas/fields'

export const clickAndCollectFormSchema = z.object({
  phone: phoneNumberField,
  firstName: nameField('first-name'),
  lastName: nameField('last-name'),
  email: emailField,
  comment: z.string().max(500).optional(),
})
